module.exports = __webpack_public_path__ + "img/background-blurred.2e8af491.png";